<div class="tree-container">
  <!-- Tree Controls -->
  <div class="tree-controls mb-3" *ngIf="filteredData.length > 0">
    <div class="d-flex justify-content-between align-items-center">
      <div class="tree-info">
        <small class="text-muted">
          <i class="fas fa-sitemap me-1"></i>
          {{ filteredData.length }} {{ filteredData.length === 1 ? 'categorie' : 'categorii' }}
          <span *ngIf="selectedCategories.length > 0">
            | {{ selectedCategories.length }} selectate
          </span>
        </small>
      </div>
      <div class="tree-actions">
        <button 
          type="button" 
          class="btn btn-outline-secondary btn-sm me-1"
          (click)="expandAll()"
          title="Extinde toate">
          <i class="fas fa-expand-arrows-alt"></i>
        </button>
        <button 
          type="button" 
          class="btn btn-outline-secondary btn-sm"
          (click)="collapseAll()"
          title="Închide toate">
          <i class="fas fa-compress-arrows-alt"></i>
        </button>
      </div>
    </div>
  </div>

  <!-- Empty State -->
  <div *ngIf="filteredData.length === 0" class="empty-state text-center py-4">
    <i class="fas fa-folder-open fa-3x text-muted mb-3"></i>
    <h6 class="text-muted">Nu există categorii</h6>
    <p class="text-muted small">
      <span *ngIf="searchTerm">Nu am găsit categorii care să corespundă căutării.</span>
      <span *ngIf="!searchTerm">Nu există categorii definite pentru organizația selectată.</span>
    </p>
  </div>

  <!-- Tree View -->
  <div class="tree-view" *ngIf="filteredData.length > 0">
    <mat-tree [dataSource]="dataSource" [treeControl]="treeControl">
      <mat-tree-node 
        *matTreeNodeDef="let node" 
        matTreeNodeToggle
        [class]="getCategoryStatusClass(node)"
        (click)="onNodeClick(node)">
        
        <div class="tree-node-content" [style.padding-left]="getNodePadding(node.level)">
          <!-- Toggle Icon -->
          <button 
            mat-icon-button 
            class="tree-toggle-btn"
            [style.visibility]="node.expandable ? 'visible' : 'hidden'"
            (click)="onToggleExpand(node); $event.stopPropagation()">
            <mat-icon>
              {{ treeControl.isExpanded(node) ? 'expand_less' : 'expand_more' }}
            </mat-icon>
          </button>

          <!-- Category Icon -->
          <mat-icon class="category-icon">{{ getCategoryIcon(node) }}</mat-icon>

          <!-- Category Info -->
          <div class="category-info flex-grow-1">
            <div class="category-name">
              {{ node.name }}
              
              <!-- Status Badges -->
              <span class="badge badge-sm ms-2" 
                    [class.badge-success]="node.active"
                    [class.badge-danger]="!node.active">
                {{ node.active ? 'Activ' : 'Inactiv' }}
              </span>
              
              <span class="badge badge-sm ms-1" 
                    [class.badge-info]="node.public_visible"
                    [class.badge-warning]="!node.public_visible">
                {{ node.public_visible ? 'Public' : 'Privat' }}
              </span>
            </div>
            
            <div class="category-description" *ngIf="node.description">
              <small class="text-muted">{{ node.description }}</small>
            </div>
            
            <div class="category-organization" *ngIf="node.directie_info || node.compartiment_info">
              <small class="text-info">
                <i class="fas fa-building me-1"></i>
                {{ node.directie_info?.name }}
                <span *ngIf="node.compartiment_info"> - {{ node.compartiment_info.name }}</span>
              </small>
            </div>
          </div>

          <!-- Template Counts -->
          <div class="template-counts" *ngIf="showTemplateCount">
            <div class="counts-container">
              <span class="badge badge-primary me-1" 
                    *ngIf="getTemplateCounts(node).document > 0"
                    title="Template-uri oficiale">
                {{ getTemplateCounts(node).document }} Doc
              </span>
              <span class="badge badge-secondary me-1" 
                    *ngIf="getTemplateCounts(node).request > 0"
                    title="Template-uri cereri">
                {{ getTemplateCounts(node).request }} Req
              </span>
              <span class="badge badge-light" 
                    *ngIf="getTemplateCounts(node).total === 0"
                    title="Fără template-uri">
                0
              </span>
            </div>
          </div>

          <!-- Selection Indicator -->
          <div class="selection-indicator" *ngIf="allowSelection">
            <mat-icon 
              *ngIf="isCategorySelected(node)" 
              class="text-primary">
              {{ allowMultiSelection ? 'check_box' : 'radio_button_checked' }}
            </mat-icon>
            <mat-icon 
              *ngIf="!isCategorySelected(node)" 
              class="text-muted">
              {{ allowMultiSelection ? 'check_box_outline_blank' : 'radio_button_unchecked' }}
            </mat-icon>
          </div>

          <!-- Actions Menu -->
          <div class="node-actions" *ngIf="showActions">
            <button 
              mat-icon-button 
              [matMenuTriggerFor]="nodeMenu"
              (click)="$event.stopPropagation()"
              class="action-menu-btn">
              <mat-icon>more_vert</mat-icon>
            </button>
            
            <mat-menu #nodeMenu="matMenu">
              <button mat-menu-item (click)="onNodeAction('edit', node)">
                <mat-icon>edit</mat-icon>
                <span>Editează</span>
              </button>
              <button mat-menu-item (click)="onNodeAction('addChild', node)">
                <mat-icon>add</mat-icon>
                <span>Adaugă Subcategorie</span>
              </button>
              <button mat-menu-item (click)="onNodeAction('viewTemplates', node)">
                <mat-icon>list</mat-icon>
                <span>Vezi Template-uri</span>
              </button>
              <mat-divider></mat-divider>
              <button mat-menu-item (click)="onNodeAction('toggleStatus', node)">
                <mat-icon>{{ node.active ? 'visibility_off' : 'visibility' }}</mat-icon>
                <span>{{ node.active ? 'Dezactivează' : 'Activează' }}</span>
              </button>
              <button mat-menu-item (click)="onNodeAction('delete', node)" class="text-danger">
                <mat-icon class="text-danger">delete</mat-icon>
                <span>Șterge</span>
              </button>
            </mat-menu>
          </div>
        </div>
      </mat-tree-node>

      <!-- Nested node -->
      <mat-nested-tree-node *matTreeNodeDef="let node; when: hasChild">
        <div class="mat-tree-node" [class]="getCategoryStatusClass(node)">
          <div class="tree-node-content" [style.padding-left]="getNodePadding(node.level)">
            <!-- Toggle Icon -->
            <button 
              mat-icon-button 
              matTreeNodeToggle 
              class="tree-toggle-btn"
              [attr.aria-label]="'Toggle ' + node.name"
              (click)="$event.stopPropagation()">
              <mat-icon class="mat-icon-rtl-mirror">
                {{ treeControl.isExpanded(node) ? 'expand_less' : 'expand_more' }}
              </mat-icon>
            </button>

            <!-- Category Icon -->
            <mat-icon class="category-icon">{{ getCategoryIcon(node) }}</mat-icon>

            <!-- Category Info -->
            <div class="category-info flex-grow-1" (click)="onNodeClick(node)">
              <div class="category-name">
                {{ node.name }}
                
                <!-- Status Badges -->
                <span class="badge badge-sm ms-2" 
                      [class.badge-success]="node.active"
                      [class.badge-danger]="!node.active">
                  {{ node.active ? 'Activ' : 'Inactiv' }}
                </span>
                
                <span class="badge badge-sm ms-1" 
                      [class.badge-info]="node.public_visible"
                      [class.badge-warning]="!node.public_visible">
                  {{ node.public_visible ? 'Public' : 'Privat' }}
                </span>
              </div>
              
              <div class="category-description" *ngIf="node.description">
                <small class="text-muted">{{ node.description }}</small>
              </div>
              
              <div class="category-organization" *ngIf="node.directie_info || node.compartiment_info">
                <small class="text-info">
                  <i class="fas fa-building me-1"></i>
                  {{ node.directie_info?.name }}
                  <span *ngIf="node.compartiment_info"> - {{ node.compartiment_info.name }}</span>
                </small>
              </div>
            </div>

            <!-- Template Counts -->
            <div class="template-counts" *ngIf="showTemplateCount">
              <div class="counts-container">
                <span class="badge badge-primary me-1" 
                      *ngIf="getTemplateCounts(node).document > 0"
                      title="Template-uri oficiale">
                  {{ getTemplateCounts(node).document }} Doc
                </span>
                <span class="badge badge-secondary me-1" 
                      *ngIf="getTemplateCounts(node).request > 0"
                      title="Template-uri cereri">
                  {{ getTemplateCounts(node).request }} Req
                </span>
                <span class="badge badge-light" 
                      *ngIf="getTemplateCounts(node).total === 0"
                      title="Fără template-uri">
                  0
                </span>
              </div>
            </div>

            <!-- Selection Indicator -->
            <div class="selection-indicator" *ngIf="allowSelection" (click)="onNodeClick(node)">
              <mat-icon 
                *ngIf="isCategorySelected(node)" 
                class="text-primary">
                {{ allowMultiSelection ? 'check_box' : 'radio_button_checked' }}
              </mat-icon>
              <mat-icon 
                *ngIf="!isCategorySelected(node)" 
                class="text-muted">
                {{ allowMultiSelection ? 'check_box_outline_blank' : 'radio_button_unchecked' }}
              </mat-icon>
            </div>

            <!-- Actions Menu -->
            <div class="node-actions" *ngIf="showActions">
              <button 
                mat-icon-button 
                [matMenuTriggerFor]="nestedNodeMenu"
                (click)="$event.stopPropagation()"
                class="action-menu-btn">
                <mat-icon>more_vert</mat-icon>
              </button>
              
              <mat-menu #nestedNodeMenu="matMenu">
                <button mat-menu-item (click)="onNodeAction('edit', node)">
                  <mat-icon>edit</mat-icon>
                  <span>Editează</span>
                </button>
                <button mat-menu-item (click)="onNodeAction('addChild', node)">
                  <mat-icon>add</mat-icon>
                  <span>Adaugă Subcategorie</span>
                </button>
                <button mat-menu-item (click)="onNodeAction('viewTemplates', node)">
                  <mat-icon>list</mat-icon>
                  <span>Vezi Template-uri</span>
                </button>
                <mat-divider></mat-divider>
                <button mat-menu-item (click)="onNodeAction('toggleStatus', node)">
                  <mat-icon>{{ node.active ? 'visibility_off' : 'visibility' }}</mat-icon>
                  <span>{{ node.active ? 'Dezactivează' : 'Activează' }}</span>
                </button>
                <button mat-menu-item (click)="onNodeAction('delete', node)" class="text-danger">
                  <mat-icon class="text-danger">delete</mat-icon>
                  <span>Șterge</span>
                </button>
              </mat-menu>
            </div>
          </div>
        </div>
        
        <div [class.tree-invisible]="!treeControl.isExpanded(node)" role="group">
          <ng-container matTreeNodeOutlet></ng-container>
        </div>
      </mat-nested-tree-node>
    </mat-tree>
  </div>
</div>